import axios from "axios";
let defaultAPIKey = process.env.REACT_APP_PUBLIC_API ?? '';
let token = localStorage.getItem("authUser") as string;
let userAPIKey = token ? "Bearer " + token : defaultAPIKey;
let apiBaseURL = "";

const loadConfig = async () => {
    const response = await fetch("/config.json");
    const config = await response.json();
    apiBaseURL = config.API_BASE_URL;
};
  
const createHttpInstance = async () => {
    await loadConfig();
    return axios.create({
      baseURL: apiBaseURL,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Authorization": userAPIKey,
        "Cache-Control": "no-store, no-cache, must-revalidate",
      },
    });
  };
  
  export default createHttpInstance;